module.exports = __webpack_public_path__ + "img/banner.0159e9fe.jpg";